module.exports = __webpack_public_path__ + "img/elec_dianchi.4777b26d.png";